import { Component, Mixins, Prop, } from "vue-property-decorator";
import { walkUpUntil } from "@/lib/helpers";
import RightsAware from "@/lib/mixins/rights-aware";
import Popper, { Placement } from "popper.js";
import { Portal } from "portal-vue";
import uuid from "uuid/v4";

class Manager {
  private current;
  constructor() { this.current = null; }
  set(next) {
    if (next === this.current) return;
    if (this.current) this.current.close();
    this.current = next;
  }
}

const manager = new Manager();

@Component
class Dropdown extends Mixins(RightsAware) {

  @Prop({default: false}) readonly openOnInit!:boolean;
  @Prop({default: false}) readonly stopTriggerPropagation!: boolean;
  @Prop({default: "bottom-start", type: String}) readonly placement!: Placement;
  @Prop({default: true}) readonly withBackground!: boolean;
  @Prop({default: ""}) readonly layerClassNames!: string;
  @Prop({default: true}) readonly closeOnClickLayer!: boolean;
  @Prop({default: true}) readonly unique!: boolean;
  @Prop({default: false}) readonly openOnHover!: boolean;
  @Prop({default: false}) readonly disabled!: boolean;

  private isHover = false;
  private isOpen = false;
  private popperInstance  = null;
  private dropdownId:string = null;

  handleMouseover(e) {

    if (!this.openOnHover) return;

    this.isHover = true;

    const $trigger = this.$refs.trigger;
    const $target = e.target;

    const isTrigger = !!walkUpUntil($target, $el => $el === $trigger);
    if (isTrigger) {
      this.stopTriggerPropagation && e.stopImmediatePropagation();
      this.open();
    }

  }

  handleMouseLeave() {
    if (!this.openOnHover) return;
    this.isHover = false;
    setTimeout(() => {
      if (!this.isHover) {
        this.close()
      }
    }, 700);
  }

  toggle(e) {
    if (this.disabled || this.isReadonly || this.openOnHover) return;
    this.stopTriggerPropagation && e.stopImmediatePropagation();
    this.isOpen ? this.close() : this.open();
  }

  created() {
    this.dropdownId = uuid();
    this.isOpen = this.openOnInit;
    this.bindOutsideClose = this.bindOutsideClose.bind(this);
  }

  open() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.unique && manager.set(this);
      document.documentElement.addEventListener("click", this.bindOutsideClose);
      this.$emit("open", this);
      this.onDropdownMounted();
    }
  }

  handleLayerClick() {
    if (this.isOpen && this.closeOnClickLayer) {
      this.isOpen = false;
    }
  }

  close() {
    if (this.isOpen) {
      this.isOpen = false;
      document.documentElement.removeEventListener("click", this.bindOutsideClose);
      if( this.popperInstance ){
        this.popperInstance.destroy();
        this.popperInstance = null;
      }
      this.$emit("close");
    }
  }

  bindOutsideClose(e) {

    const $layer = this.$refs.layer;
    const $trigger = this.$refs.trigger;
    const $target = e.target;

    const isTrigger = !!walkUpUntil($target, $el => $el === $trigger);

    if (isTrigger) {
      this.stopTriggerPropagation && e.stopImmediatePropagation();
      return null;
    }

    // walk the dom up from $target to $layer. no layer found => click outside
    const isLayer = walkUpUntil($target, $el => $el === $layer);
    if (!isLayer) this.close();
  }

  onDropdownMounted() {
    this.$nextTick(() => {
      const dropDownLayer = document.querySelector(`.dropdown-portal .dropdown-${this.dropdownId}`);
      this.popperInstance = new Popper( this.$el, dropDownLayer, {
        placement:this.placement,
        positionFixed: true
      });
    });
  }

  render() {
    return (
      <div
        class={`dropdown ${this.isOpen ? "is-open" : ""}`}é
        onMouseleave={this.handleMouseLeave}
        onMouseover={this.handleMouseover}>
          <span class={`dropdown-trigger ${this.isReadonly ? 'is-readonly': ''}`} ref="trigger" onClick={this.toggle} >
            {this.$scopedSlots.trigger({})}
          </span>

        {this.isOpen && (
          <Portal to="dropdown">
            <div
              onClick={ this.handleLayerClick }
              class={`dropdown-layer dropdown-${this.dropdownId} ${!this.withBackground ? "no-background" : ""} ${this.layerClassNames}`}
              ref="layer">
              { this.$scopedSlots.layer({ close: this.close }) }
            </div>
          </Portal>
        )}

      </div>
    );
  }
}

export default Dropdown;

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2d5d8f16/dropdown.tsx" });